export type SseEvent = { event: string; data: unknown };

/** Tách luồng SSE (`event:` + `data:` JSON, dòng trống kết thúc sự kiện). Bỏ qua sự kiện hỏng. */
export async function* parseSse(body: ReadableStream<Uint8Array>): AsyncGenerator<SseEvent> {
  const reader = body.getReader();
  const dec = new TextDecoder();
  let buf = '';
  const flush = (chunk: string): SseEvent | null => {
    let event = 'message';
    const data: string[] = [];
    for (const line of chunk.split('\n')) {
      if (line.startsWith('event:')) event = line.slice(6).trim();
      else if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
    }
    if (data.length === 0) return null;
    try { return { event, data: JSON.parse(data.join('\n')) }; } catch { return null; }
  };
  try {
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += dec.decode(value, { stream: true }).replace(/\r\n/g, '\n');
      let i: number;
      while ((i = buf.indexOf('\n\n')) >= 0) {
        const ev = flush(buf.slice(0, i));
        buf = buf.slice(i + 2);
        if (ev) yield ev;
      }
    }
    const last = buf.trim() ? flush(buf) : null;
    if (last) yield last;
  } finally {
    reader.releaseLock();
  }
}
